import { Helmet } from "react-helmet";
import { Button, Img, Input, Heading, Text } from "../../components";

import CarCard from "../../components/CarCard";
import UserProfile1 from "../../components/UserProfile1";
import React, { Suspense, useStatem, useEffect, useState } from "react";
import RightSideMenuProvider from "components/RightSideMenuProvider";
import MyAdsProvider from "components/MyAdsProvider";
import FilterBar from "components/FilterBar";
//import TestFile1AfterRow from "components/TestFile1AfterRow";
import AllCarsLines from "components/TestFile1AfterRow";
import axios from "axios";
import {API_DOMAIN_IMG, API_DOMAIN} from 'config';
import { useLocation } from 'react-router-dom';
const tabs = [
  "מודעות בארכיון",
  //"חבילת רכבים",
 // "מודעות במכרז",
  "מודעות חדשות",
  "כל המודעות",
];
export default function DealerrProfil(
    {currentUser,setCurrentUser,


    }) {

const [errors, setErrors] = useState({});
const [errorMessage, setErrorMessage] = useState("");     
const [loading, setLoading] = useState(false);
const [cars, setCars] = useState([]);
const [formData, setFormData] = useState({
    name: "",                 // ✅ שם משתמש
  businessName:            "",   // שם העסק
  contactName:             "",   
  fullAddress:             "",   // כתובת מלאה
  //businessLicenseNumber:   "",   // רישוי
  phone:                   "",   // נייד
  email:                   "",   // אימייל
});
const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({ ...prev, [name]: value }));
  setErrors((prev) => ({ ...prev, [name]: "" }));
};

useEffect(() => {
  if (!currentUser?.id) return;

  const fetchUser = async () => {
    try {
      const { data } = await axios.get(`${API_DOMAIN}/user/getUserById`, {
        params: { id: currentUser.id },
      });

      if (data?.user) {
        setFormData({
              name:        data.user.name ?? "",
          contactName:           data.user.contact_name ?? "",
          fullAddress:           data.user.full_address ?? "",
          phone:                 data.user.phone_number ?? data.user.phone ?? "",
          email:                 data.user.email ?? "",
        });
      } else {
        console.log("getUserById response:", data);
      }
    } catch (err) {
      console.error("שגיאה בשליפת פרטי משתמש:", err);
    }
  };

  fetchUser();
}, [currentUser?.id]);


  const validatePhone = (phone) => {
    const phoneRegex =
      /^((\+972|972)|0)5([0|1|2|3|4|5|6|8|9])( |-)?([0-9]{7})$/;
    return phoneRegex.test(phone);
  };

const handleSave = async () => {
  const errs = {};
if (!formData.name.trim()) errs.name = "שדה חובה";
// ואם גם בית עסק חובה:


  if (!formData.contactName.trim()) {
    errs.contactName = "שדה חובה";
  }

  if (!formData.fullAddress.trim()) {
    errs.fullAddress = "שדה חובה";
  }


  if (!validatePhone(formData.phone)) {
    errs.phone = "נייד לא תקין";
  }

  if (!/\S+@\S+\.\S+/.test(formData.email)) {
    errs.email = "אימייל לא תקין";
  }

  if (Object.keys(errs).length) {
    setErrors(errs);
    return;
  }

  await updateUserOnServer();
};


/* קריאה פנימית מעודכנת */
const updateUserOnServer = async () => {
  const fd = new FormData();
  fd.append("id", currentUser.id);

  fd.append("name", formData.name.trim());                  // ✅ שם משתמש

  fd.append("contact_name", formData.contactName.trim());
  fd.append("full_address", formData.fullAddress.trim());
  fd.append("phone", formData.phone.trim());
  fd.append("email", formData.email.trim());

  const res = await fetch(`${API_DOMAIN}/user/updateUser`, { method: "POST", body: fd });
  const data = await res.json();

  if (data.success) {
    alert("הפרטים נשמרו בהצלחה!");
    setCurrentUser((prev) => ({ ...prev, ...data.user })); // טוב
  } else {
    setErrorMessage(data.error ?? "שמירה נכשלה");
  }
};

   







  return (
    <>

      <div className="dealer-profil flex bg-blue_gray-50 md-p-8">
        <div className="w-[100%] items-start gap-4 md:flex-col" style={{gap: '2%'}}>
         
<div className="main-section profil-wrapper h-[95.5vh] flex relative flex-1 flex-col gap-8 self-center rounded-[24px] bg-secondary-primary_white p-6 md:self-stretch sm:p-4">          <header className="flex flex-col items-start gap-3">

              <div className="flex items-center justify-between gap-5 mt-5 self-stretch border-b border-solid border-gray-200 md:flex-col">
                <div className="flex w-[6%] justify-center gap-3.5 md:w-full">

             
                </div>
           
                <div className="flex gap-3">
                  <Heading size="heading9xl" as="h4" className="!font-heebo text-[25px] font-bold lg:text-[21px]">
                  הפרופיל שלי
                  </Heading>
                  <Img src="/images/profile.svg" alt="Car" className="icon-mobile-offer h-[28px]" />
                </div>
              </div>
            </header>
<div className="flex flex-col gap-6 w-[30%] sm:w-full self-end">
           <div className="mb-[34px] flex flex-col items-center gap-[46px] md:mx-0">
                  <div className="flex flex-col gap-5 self-stretch">
                    <div className="flex flex-col items-end gap-0.5">
                      <Text
                        size="h4_assistant16px_r"
                        as="p"
                        className="mr-[18px] text-[16px] font-semibold lg:text-[13px] md:mr-0"
                      >
                        <span className="text-red-a700_03">*</span>
                        <span className="text-black-900_03">שם</span>
                      </Text>
         <Input
  size="sm"
  name="name"                       // ← שם תואם ל-formData
  placeholder="רשמו פה את  שם המשתמש"
  value={formData.name}             // ← אותו מפתח
  onChange={handleChange}
  className={`self-stretch rounded-[16px] border px-3
              ${errors.name ? "border-red-500" : ""}`}
/>
{errors.name && (
  <Text className="text-red-500">{errors.name}</Text>
)}

                    </div>

                    <div className="flex flex-col items-end gap-0.5">
  <Text
    size="h4_assistant16px_r"
    as="p"
    className="mr-[18px] text-[16px] font-semibold lg:text-[13px] md:mr-0"
  >
    <span className="text-red-a700_03">*</span>
    <span className="text-black-900_03">שם איש קשר</span>
  </Text>

  <Input
    size="sm"
    name="contactName"
    placeholder="רשמו פה את שם איש הקשר"
    value={formData.contactName}
    onChange={handleChange}
    className={`self-stretch rounded-[16px] border px-3
                ${errors.contactName ? "border-red-500" : ""}`}
  />

  {errors.contactName && (
    <Text className="text-red-500">{errors.contactName}</Text>
  )}
</div>



                          <div className="flex flex-col items-end gap-0.5">
                      <Text
                        size="h4_assistant16px_r"
                        as="p"
                        className="mr-[18px] text-[16px] font-semibold lg:text-[13px] md:mr-0"
                      >
                        <span className="text-red-a700_03">*</span>
                        <span className="text-black-900_03">כתובת העסק</span>
                      </Text>
<Input
  size="sm"
  name="fullAddress"
  placeholder="רשמו פה את כתובת העסק"
  value={formData.fullAddress}
  onChange={handleChange}
  className={`self-stretch rounded-[16px] border px-3
              ${errors.fullAddress ? "border-red-500" : ""}`}
/>
{errors.fullAddress && (
  <Text className="text-red-500">{errors.fullAddress}</Text>
)}
                    </div>
       
                          <div className="flex flex-col items-end gap-0.5">
                      <Text
                        size="h4_assistant16px_r"
                        as="p"
                        className="mr-[18px] text-[16px] font-semibold lg:text-[13px] md:mr-0"
                      >
                        <span className="text-red-a700_03">*</span>
                        <span className="text-black-900_03">נייד</span>
                      </Text>
 <Input
  size="sm"
  name="phone"
  placeholder="רשמו פה את מספר הנייד"
  value={formData.phone}
  onChange={handleChange}
  className={`self-stretch rounded-[16px] border px-3
              ${errors.phone ? "border-red-500" : ""}`}
/>
                  </div>
                    
                    <div className="flex flex-col items-end gap-0.5">
                      <Heading
                        size="h4_assistant_16px_b"
                        as="h2"
                        className="mr-[18px] text-[16px] font-semibold lg:text-[13px] md:mr-0"
                      >
                        <span className="text-red-a700_03">*</span>
                        <span className="text-black-900_03" style={{fontWeight: "bold"}}>אימייל</span>
                      </Heading>
                  <Input
  size="sm"
  type="email"
  name="email"
  placeholder="רשמו פה את האימייל"
  value={formData.email}
  onChange={handleChange}
  className={`self-stretch rounded-[16px] border px-3
              ${errors.email ? "border-red-500" : ""}`}
/>
{errors.email && (
  <Text className="text-red-500">{errors.email}</Text>
)}
                    </div>
                  </div>
                  {/* הודעת שגיאה כללית */}
{errorMessage && (
  <Text className="mt-3 text-center text-red-600">
    {errorMessage}
  </Text>
)}

                  <div className="flex w-[24%] justify-center lg:w-full md:w-full">
                    <div className="w-full">
                 
                    </div>
                  </div>


                </div>




            </div>
<div className="wrap-button">
<Button
  onClick={handleSave}
  className="
    save-button-profil
    h-[40px]                  /* גובה קבוע */
    w-full                    /* כברירת-מחדל (מובייל) */
    md:absolute md:top-[19%]  /* בדסקטופ בלבד */
    md:w-[5%]                 /* בדסקטופ 5% */
    gap-2 rounded-[20px]
    bg-red-800 text-secondary-primary_white
    font-semibold text-[16px] lg:text-[13px]
  "
>
   שמירה
</Button>
</div>

          </div>
          
        </div>
      </div>

    </>
  );
}
